module.exports = __webpack_public_path__ + "static/media/22_after.8568df64.jpg";